import React from 'react';
import './Service.css';
import ServiceHead from '../assets/wmremove-transformed.png';

import nailservice from '../assets/NAILSER.PNG';
import hairservice from '../assets/polygelnew.PNG';
import lashservice from '../assets/body.PNG';
import waxing from '../assets/hairstyling.PNG';
import skinCare from '../assets/specialoffers.png';


const Service = () => {
    return (
        <>
        <div>
            <div>
                <img src={ServiceHead} className='serviceimge mt-2' style={{ width: '100%', height: '75vh', objectFit: 'cover' }} />
            </div>
            <div className='p-5'>
            <div className='Lorem1 ps-5 ms-5'>MSilk Spa</div>
        <div className='servicesimagctnt  ps-3 ms-5' style={{maxWidth:"600px"}} >
        At MSilk Spa, we specialize increating stunning nail designs, from coveted Russian Manicures to intricatenail art and
        long-lasting gel finishes. Beyond nails, we offer waxing and hair care treatments to complete your self care routine. Every visit is designed to leave you feeling pampered and polished.
        </div>
        </div>
        </div>

      <h1 className="text-center pt-4 servicecontent"
      style={{fontStyle: 'italic',fontFamily: "'TAN TWINKLE', san serif",}}>Services and Prices</h1>
      <h6 className='servicesubcontent '>Lorem ipsum dolor curabitur sed tellus ipsum. Sed tristique ut orci ut gravida. Curabitur sed tellus ipsum.</h6>
      <div className="container d-flex justify-content-center pt-3  ">
    <div className="row align-items-center">

        <div className="col-sm-5 text-">
            <img src={nailservice}  alt="Nail Services" className='img-fluid serviceimage' style={{width: "100%", height: "300px", borderRadius: "0px"}} />
        </div>

        <div className="col-sm-7 p-5 ">
            <h1 className="russian text-start">Russian Nail</h1>
            <span className='russiancontent'>Lorem ipsum dolor curabitur sed tellus ipsum</span>
            <p className='russianmain pt-2'>Russian Manicure Gel Polish<span className='servicetime ps-1 '>1hr</span><span className='servicetime ps-1 '>30min</span><span className='servicefrom ps-1'>............... <span className='servicefrom ps-1'>from</span></span><span className='serviceamt ps-1'>$55</span></p>
            <p className='russianmain pt-1'>Russian Hard Gel Manicure<span className='servicetime ps-1 '>2hr</span><span className='servicetime ps-1 '></span><span className='servicefrom ps-1'>............... <span className='servicefrom ps-1'>from</span></span><span className='serviceamt ps-1'>$65</span></p>
            <p className='russianmain pt-1'>Russian Gel Pedicure (Special)<span className='servicetime ps-1 '>2hr</span><span className='servicetime ps-1 '></span><span className='servicefrom ps-1'>............... <span className='servicefrom ps-1'>from</span></span><span className='serviceamt ps-1'>$65</span></p>
            <p className='russianmain pt-1'>Russian Gel Extentions (Medium)<span className='servicetime ps-1 '>2hr</span><span className='servicetime ps-1 '>15min</span><span className='servicefrom ps-1'>............... <span className='servicefrom ps-1'>from</span></span><span className='serviceamt ps-1'>$95</span></p>
            <p className='russianmain pt-1'>Russian Gel + Pedi<span className='servicetime ps-1 '>3hr</span><span className='servicetime ps-1 '>30min</span><span className='servicefrom ps-1'>............... <span className='servicefrom ps-1'>from</span></span><span className='serviceamt ps-1'>$140</span></p>
        </div>
    </div>
</div>

<div className="container d-flex justify-content-center pt-3">
    <div className="row align-items-center">
    <div className="col-sm-7 p-5">
            <h1 className="russian text-start">Regular & Polygel</h1>
            <span className='russiancontent'>Lorem ipsum dolor curabitur sed tellus ipsum</span>
            <p className='russianmain pt-2'>Regular Gel polish Manicure overlay<span className='servicetime ps-1 '>2hr</span><span className='servicetime ps-1 '></span><span className='servicefrom ps-1'>............... <span className='servicefrom ps-1'>from</span></span><span className='serviceamt ps-1'>$40</span></p>
            <p className='russianmain pt-1'>Gel X Extentions (Medium)<span className='servicetime ps-1 '>2hr</span><span className='servicetime ps-1 '></span><span className='servicefrom ps-1'>............... <span className='servicefrom ps-1'>from</span></span><span className='serviceamt ps-1'>$90</span></p>
            <p className='russianmain pt-1'>Polygel Extentions(Short)<span className='servicetime ps-1 '>2hr</span><span className='servicetime ps-1 '></span><span className='servicefrom ps-1'>............... <span className='servicefrom ps-1'>from</span></span><span className='serviceamt ps-1'>$90</span></p>
            <p className='russianmain pt-1'>Polygel Extentions(Medium)<span className='servicetime ps-1 '>2hr</span><span className='servicetime ps-1 '></span><span className='servicefrom ps-1'>............... <span className='servicefrom ps-1'>from</span></span><span className='serviceamt ps-1'>$100</span></p>
            <p className='russianmain pt-1'>Polygel Extentions(Long)<span className='servicetime ps-1 '>2hr</span><span className='servicetime ps-1 '></span><span className='servicefrom ps-1'>............... <span className='servicefrom ps-1'>from</span></span><span className='serviceamt ps-1'>$120</span></p>
        </div>
        <div className="col-sm-5">
        <img src={hairservice} className='serviceimage' alt="Nail Services" style={{width: "100%", height: "400px", borderRadius: "0px"}} />        </div>

      
    </div>
</div>
<div className="container d-flex justify-content-center pt-3">
    <div className="row align-items-center">

        <div className="col-sm-5">
        <img src={lashservice} className='serviceimage' alt="Nail Services" style={{width: "100%", height: "400px", borderRadius: "0px"}} />        </div>

        <div className="col-sm-7 p-5">
            <h1 className="russian text-start">Face & Body</h1>
            <span className='russiancontent text-start'>Lorem ipsum dolor curabitur sed tellus ipsum</span>
            <p className='russianmain pt-2'>Eyebrows Waxing & Shape<span className='servicetime ps-1 '>10min</span><span className='servicetime ps-1 '></span><span className='servicefrom ps-1'>............... <span className='servicefrom ps-1'>from</span></span><span className='serviceamt ps-1'>$15</span></p>
            <p className='russianmain pt-1'>Full Face Wax<span className='servicetime ps-1 '>15min</span><span className='servicetime ps-1 '></span><span className='servicefrom ps-1'>............... <span className='servicefrom ps-1'>from</span></span><span className='serviceamt ps-1'>$30</span></p>
            <p className='russianmain pt-1'>Full Body Wax<span className='servicetime ps-1 '>30min</span><span className='servicetime ps-1 '></span><span className='servicefrom ps-1'>............... <span className='servicefrom ps-1'>from</span></span><span className='serviceamt ps-1'>$150</span></p>
        </div>
    </div>
</div>

<div className="container d-flex justify-content-center pt-3 pb-5">
    <div className="row align-items-center">
    <div className="col-sm-7 p-5">
            <h1 className="russian text-start">Hair Styling</h1>
            <span className='russiancontent'>Lorem ipsum dolor curabitur sed tellus ipsum</span>
            <p className='russianmain pt-2'>Wash Blow-dry Style (December Special)<span className='servicetime ps-1 '>40min</span><span className='servicetime ps-1 '></span><span className='servicefrom ps-1'>............... <span className='servicefrom ps-1'>from</span></span><span className='serviceamt ps-1'>$30</span></p>
            <p className='russianmain pt-1'>Single Process Color Hair (December Special )<span className='servicetime ps-1 '>1hr</span><span className='servicetime ps-1 '></span><span className='servicefrom ps-1'>............... <span className='servicefrom ps-1'>from</span></span><span className='serviceamt ps-1'>$70</span></p>
            <p className='russianmain pt-1'>Beach Waves<span className='servicetime ps-1 '>1hr</span><span className='servicetime ps-1 '></span><span className='servicefrom ps-1'>............... <span className='servicefrom ps-1'>from</span></span><span className='serviceamt ps-1'>$60</span></p>
        </div>
        <div className="col-sm-5">
        <img src={waxing} className='serviceimage' alt="Nail Services" style={{width: "100%", height: "400px", borderRadius: "0px"}} />       
         </div>    
    </div>
</div>



<div className="container pt-5 mt-5 pb-5 mb-5">
    <div className="row align-items-center text-center text-sm-start">
        <div className="col-12 col-sm-7">
            {/* <h1 className="text- pt-2 offerservice">Services</h1> */}
            <h3 className='sploffer'>Special Offers</h3>
            <p className='offercontent'>
                Lorem ipsum dolor curabitur sed tellus ipsum. Sed tristique ut <br />
                orci ut gravida. Curabitur sed tellus ipsum. Sed tristique ut orci ut <br />
                gravida. Lorem ipsum dolor curabitur sed tellus ipsum. Sed <br />
                tristique ut orci ut gravida.
            </p>
        </div>
        <div className="col-12 col-sm-5">
            <img src={skinCare} className='offerimage img-fluid' alt="Nail Services" 
                style={{ width: "100%", borderRadius: "0px" }} />
        </div>
    </div>
</div>

  </>
    );
}

export default Service;

 